import { LogsService } from '@/services/logs.service'

export default {
  getUnsolvedCount({ commit }) {
    return LogsService.unsolvedCount()
      .then((response) => commit('SET_LOGS_UNSOLVED_COUNT', response.data.content))
      .catch((error) =>
        commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
      )
  },
}
